import FeeWaiverManagement from "./FeeWaiverManagement";
import { connect } from "react-redux";
import { actions } from "./feeWaiverManagementActions";

export default connect(
  state => ({ FeeWaiverManagementReducer: state.FeeWaiverManagementReducer }),
  actions
)(FeeWaiverManagement);